function getPrevFlow(flow) {
  return $(flow).parents(".block-flow-container").prevAll(".block-flow-container").first().find(".flow");
}

function getButtonContainerForFlow(flow) {
  return $(".block-button-container[data-day=" + flow.data('day') + "]");
}

function getBlockContent(currentDay) {
  var currentFlow = $(".flow[data-day=" + currentDay + "]");
  var currentState = currentFlow.data("state");
  var prevFlow = currentFlow;
  var flowContainers = [];
  while(prevFlow.length > 0 && currentState == prevFlow.data("state")) {
    if(prevFlow != currentFlow) {
      flowContainers.push($(".block-button-container[data-day=" + prevFlow.data("day") + "]").get()[0]);
    }
    flowContainers.push(prevFlow.parents(".block-flow-container").get()[0]);
    var prevDay = $(prevFlow).data('prev-day');
    prevFlow = $(".flow[data-day=" + prevDay + "]");
  }
  return $(flowContainers);
}

function createSlider(buttonContainer, blockContent) {
  var sliderClass = 'slider-' + Math.floor(Math.random() * 11000);

  buttonContainer.after('<div class="slider ' + sliderClass + '"></div>');
  var slider = $("." + sliderClass);

  $(blockContent).each(function(index, el) {
    var detached = $(el).detach();
    slider.append(detached);
  });
  return slider;
}

function removeSlider(slider) {

  slider.children().each(function(index, el) {
    var detached = $(el).detach();
    slider.before(detached);
  });

  slider.remove();
}

function blockButtonHideClick(source, dataParameterId) {
  var buttonContainer = source.parents(".block-button-container");
  var currentDay = buttonContainer.data("day");
  var currentFlow = $(".flow[data-day=" + currentDay + "]");
  var currentState = currentFlow.data("state");

  if (buttonContainer.nextAll().find(".flow.modified").length > 0) {
    if (!confirm("Máte neuložený záznam. Chcete pokračovat bez uložení?")) {
      highlightModified(buttonContainer.nextAll());
      return;
    }
    ;
  }

  var blockContent = getBlockContent(currentDay);

  $(blockContent).find(".flow").removeClass("block-visible");

  $("#container").data('reloading-day', buttonContainer.data('day'));
  $("#container").data('reloading-hidden', true);
  $("#container").data('reloading-has-button', true);

  if(dataParameterId) {
    buttonContainer.nextAll().addClass("marked-to-remove");
    buttonContainer.addClass("marked-to-remove");
    var link = buttonContainer.data(dataParameterId);
    $.nette.ajax(link);
  }

  var slider = createSlider(buttonContainer, blockContent);

  slider.slideUp(500, function() {
    slider.children().hide();
    removeSlider(slider);
    buttonContainer.html($('.button-' + currentState + '-show').html());
  });

}

function blockButtonShow(source) {
  var buttonContainer = $(source).parents(".block-button-container");
  var currentDay = buttonContainer.data("day");
  var currentFlow = $(".flow[data-day=" + currentDay + "]");
  var currentState = currentFlow.data("state");

  var blockContent = getBlockContent(currentDay);

  $(blockContent).find(".flow").addClass("block-visible");

  var slider = createSlider(buttonContainer, blockContent);

  slider.hide();
  slider.children().show();
  slider.slideDown(500, function() {
    removeSlider(slider);
    buttonContainer.html($('.button-' + currentState + '-hide').html());
  });
}

function ajaxInit() {
  $.nette.init();
  $.nette.ext('loaders', {
    'start': function(jqXHR, settings) {
      if(settings.nette != undefined) {
        $(settings.nette.el).parents(".flow").find(".ajax-loader").show();
      }
      if(settings.source != undefined) {
        $(settings.source).parents(".flow").find(".ajax-loader").show();
      }
    }
  });
  $.nette.ext('snippets').beforeQueue.add(function ($el) {
    $('.tooltip').remove();
    $(".ajax-loader-global").show();
    fixHeight();
    $(".marked-to-remove").remove();
  });
  $.nette.ext('snippets').afterQueue.add(function ($el) {
    $('.tooltip').remove();
    unfixHeight();
    refreshBlockButtons(true);
    reInit();
    $(".ajax-loader-global").hide();
  });
  $(document).ajaxStart(function() {
    $(".ajax-loader-global").show();
  });
  $(document).ajaxComplete(function() {
    refreshBlockButtons(true);
    $(".ajax-loader").hide();
  });
}

$(document).ready(function() {
  ajaxInit();
  refreshBlockButtons();
  pageInit();
  var bowser = require('bowser')
  if (bowser.android && !bowser.chrome) {
    $(".flow-star-container span").data("placement", "left");
  }
  if ($(window).width() < 768) {
    $(".has-tooltip.score").data("placement", "left");
  }
  reInit();
  pingInit();
  initInfiniteScroll();
});

function fixHeight() {
  var height = parseInt($('#content').css('height'));
  var minheight = parseInt($('#content').css('min-height'));
  $('#content').css('min-height', Math.max(height, minheight) + "px");
}

function unfixHeight() {
  $('#content').css('min-height', '0px');
}

function pageInit() {
  initBrowserCloseEvents();

  $("body").tooltip({selector: '.has-tooltip:not(.only-flow .intro-tooltip)', container: "#container"});

  $("#container").on('click', ".flow *", function () {
    var currentFlow = $(this).parents(".flow");
    var buttonContainer = getButtonContainerForFlow(currentFlow);
    $("#container").data('reloading-day', currentFlow.data('day'));
    $("#container").data('reloading-hidden', false);
    $("#container").data('reloading-has-button', buttonContainer.find(".block-button").length > 0);
  });

  $("#container").on('click', ".flow.flow-display-mode .flow-star", function() {
    var link = $(this).attr('data:edit-link');
    $.nette.ajax({'url': link, source: this});
  });

  $("#container").on('click', ".flow.flow-display-mode .flow-text, .flow.flow-display-mode .flow-score", function() {
    var link = $(this).parents(".flow").find("a.edit-link")[0].href;
    $.nette.ajax({'url': link, source: this});
  });

  $("#container").on('click', ".block-button-empty.block-button-hide .btn", function() {
    blockButtonHideClick($(this), 'reload-skip-url');
  });

  $("#container").on('click', ".block-button-skipped.block-button-hide .btn", function() {
    blockButtonHideClick($(this));
  });

  $("#container").on('click', ".block-button-show .btn", function() {
    blockButtonShow($(this));
  });

  $("body").on('click', ".js-collapse-footer", function() {
    $(this).hide();
    $("#footer").addClass("collapsed");
  });
}

function reInit() {
  $('.only-flow .intro-tooltip:not(.tooltip-initialized)').tooltip({
    trigger: 'manual',
    container: "#container"
  }).tooltip('show').addClass("tooltip-initialized");

  $(".flow textarea").bind('propertychange keyup input paste', function () {
    $(this).parents(".flow").addClass("modified");
  });

  $(".flow input[type=checkbox]").change(function () {
    $(this).parents(".flow").addClass("modified");
  });
}

var loadInProgress = false;

function initInfiniteScroll() {
  $('#container').scrollPagination({
    'contentSelector': "#container .link:last", // selector of link where i get next data
    'scrollTarget': $(window),
    'heightOffset': 10
  });
  $.nette.ext('inifiniteScrollPreload', {
    'start': function(jqXHR, settings) {
      console.log("scroll load start");
      loadInProgress = true;
    },
    'complete': function(jqXHR, settings) {
      console.log("scroll load stop");
      loadInProgress = false;
    }
  });
  checkInfiniteScroll();
  setInterval(function() {
    checkInfiniteScroll();
  }, 2000);
};



function checkInfiniteScroll() {
  var contentHeight = $("#content").height();
  var windowHeight = $(window).height();
  if((contentHeight <= windowHeight) && !loadInProgress) {
    loadMore();
  }
}

function loadMore() {
  var link = $("#container .link:last").attr("href");
  if(!link) {
    return; //we are on the end
  }
  $.nette.ajax({'url': link});
}

function refreshBlockButtons(animation) {
  var flows = $(".flow");
  flows.each(function(index, currentFlow) {
    currentFlow = $(currentFlow);
    var buttonContainer = getButtonContainerForFlow(currentFlow);
    var currentState = currentFlow.data('state');

    var prevFlow = getPrevFlow(currentFlow);
    var prevState = prevFlow.data('state');
    if(prevFlow.data('day') == flows.first().data('day')) {
      prevState = 'first';
    }

    var prevPrevFlow = getPrevFlow(prevFlow);
    var prevPrevState = prevPrevFlow.data('state');
    if(prevPrevFlow.data('day') == flows.first().data('day')) {
      prevPrevState = 'first';
    }

    var buttonPresent = $(buttonContainer).find('.block-button').length > 0;
    if(currentState != prevState && prevState != undefined) {
      var currentDay = $(buttonContainer).data("day");
      var blockContent = getBlockContent(currentDay);
      var hideBlock = true;

      //defaultni nastaveni
      if(currentState == "valid") {
        hideBlock = false;
      }

      if(currentState == 'empty' &&
        (prevState == 'first' || prevPrevState == 'first') &&
        blockContent.has('.flow').length <= 2
      ) {
        hideBlock = false;
      }

      //custom
      if($(buttonContainer).find('.block-button-show').length > 0) {
        hideBlock = true;
      }

      if($(buttonContainer).find('.block-button-hide').length > 0) {
        hideBlock = false;
      }
      var animateCurrent = animation;

      //do not hide block containing previously visible items
      if($(blockContent).find('.flow.block-visible').length > 0) {
        hideBlock = false;
      }

      //$(blockContent).find('.flow[data-day="' + $("#container").data('reloading-day') + '"]');
      if($(blockContent).find('.flow[data-day="' + $("#container").data('reloading-day') + '"]').length > 0 &&
        $("#container").data('reloading-hidden') != undefined) {
        //alert(currentDay + " -> " + $("#container").data('reloading-hidden'));
        hideBlock = $("#container").data('reloading-hidden');
        animateCurrent = !$("#container").data('reloading-has-button');
      }
      $("#container").removeData('reloading-day');
      $("#container").removeData('reloading-hidden');
      $("#container").removeData('reloading-has-button');

      var buttonHtml = "";
      if(currentState == 'valid') {
        buttonHtml = "";
        animateCurrent = false;
      } else {
        if(hideBlock) {
          buttonHtml = $('.button-' + currentState + '-show').html();
        } else {
          buttonHtml = $('.button-' + currentState + '-hide').html();
        }
      }

      if(!buttonPresent && animateCurrent) {
        $(buttonContainer).hide();
      }
      if(hideBlock) {
        $(buttonContainer).html(buttonHtml);
        blockContent.hide();
      } else {
        $(buttonContainer).html(buttonHtml);
        blockContent.show();
      }
      if(!buttonPresent && animateCurrent) {
        $(buttonContainer).slideDown(500);
      }
    } else {
      //remove button
      if(buttonPresent && animation) {
        $(buttonContainer).slideUp(500, function() {
          $(buttonContainer).html('');
          $(buttonContainer).show();
        });
      } else {
        $(buttonContainer).html('');
      }
    }

  });
};

/** Check if flow/flows are not in edit mode when want to close browser */

function initBrowserCloseEvents() {
  $(window).on('beforeunload', function (e) {
    if (isDirty()) {
      highlightModified();
      return 'Máte neuložený záznam. Chcete flow-lístek opustit bez uložení?';
    }
  });
}

function highlightModified(container) {
  if (container == undefined) {
    container = $("body");
  }
  container.find(".modified").addClass("modified-highlight");
  $('html, body').animate({
    scrollTop: container.find(".modified").first().offset().top - 150
  }, 1000);
}

function isDirty() {
  var modifiedEls = $(".modified");
  return modifiedEls.length > 0;
}

function pingInit() {
  setInterval(function () {
    var link = $("#pingLink").attr("href");
    $.ajax(link);
  }, 300000);// 5min == 300 000 ms
}
